/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AOS from 'aos'
import LoginNav from "../components/header/LoginNav";
import Reset from "../components/Reset/resetModal";
import { SIGNUP_ROUTE } from "../helpers/constants";

const Login = () => {
  const [show, setshow] = useState(false);

  useEffect(() => {
    AOS.init({ once: true })
  }, [])
  const [showModal, setShowModal] = useState(false)

  const closeModal = () => {
    setShowModal(!showModal)
  }

  return (
    <div className="relative bg-white">
      <Reset isOpen={show} setIsOpen={setshow} /> 

      <div className="mx-auto max-w-7xl mb-8 sm:mb-12 md:mb-16">
        <LoginNav />
        <div className='flex items-center flex-wrap mb-20 md:gap-0 py-8 sm:py-12 md:py-16'>
          <div className='w-full sm:w-1/2 px-4 sm:px-8 md:px-10'>
            <div className='lg:mx-10 xl:mx-16 p-4 md:p-10 border border-oya-ghana-border shadow-form rounded-xl'>
              <div className='text-left'>
                <h1 className='text-oya-ghana-header-h5 md:text-oya-ghana-header-h3 pb-6 font-bold'>
                  Welcome
                </h1>
                <h3 className='text-oya-ghana-header-h5 pb-5'>
                  Sign in to continue travelling with ease
                </h3>

                <p className='text-sm pb-5'>
                  Enter your phone number and pin to access your account
                </p>
              </div>

              <form className='w-full'>
                <div className='w-full mb-6'>
                  <label className='text-gray-500 text-sm'>Mobile number</label>
                  <input
                    type='text'
                    autoFocus={false}
                    className='w-full px-4 mt-2 bg-white border border-gray-200 outline-none rounded-md h-10'
                  />{' '}
                </div>
                <div className='my-6'>
                  <h5 className='text-gray-500 text-sm'>PIN</h5>
                  <input
                    type='password'
                    className='w-full px-4 mt-2 mb-4 border border-gray-200 rounded-md outline-none h-10'
                  />{' '}
                  <br />
                  <p className="text-sm font-light pt-4">
                    Do you forget your pin?{" "}
                    <span className="font-bold pt-3 cursor-pointer"
                      onClick={() => setshow(true)}
                    >
                      Reset PIN
                    </span>
                  </p>
                </div>
                <button
                  type="submit"
                  className="w-full my-5 bg-oya-ghana-green text-oya-ghana-header-h6 rounded-md py-2 text-white"
                >
                  Login
                </button>

                <p className='mt-2 text-center font-light'>
                  Dont have an account?{' '}
                  <Link href={SIGNUP_ROUTE} className='font-bold'>
                    Sign Up
                  </Link>{' '}
                </p>
              </form>
            </div>
          </div>

          <div className='hidden sm:block w-full sm:w-1/2'>
            <div className='md:px-5 '>
              <img
                src='/assets/images/login/login.png'
                data-aos='zoom-in'
                data-aos-duration='1500'
                alt='login-hero'
              />
              <div className='flex flex-col items-start'>
                <h1 className='lg:text-oya-ghana-header-h3 leading-tight text-2xl my-5 font-bold lg:w-[70%] md:[100%]  '>
                  Get Started in one, two, three...
                </h1>
                <p className='my-5 lg:w-[70%]'>
                  Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                  Dolorem, eum. Soluta nulla ratione laboriosam officia nihil?
                  Cupiditate libero repellendus nemo!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login
